###
This is a footer designed for use outside the CBI app (for example, on the
Login page).
###
angular.module('rjmNg.directives').directive "publicFooter", [
  ->
    restrict: "E"
    templateUrl: "directive.publicFooter.html"
    replace: true
    scope: {}
    controllerAs: "view"
    bindToController: true
    controller: [
      () ->

        view = @

        view.year = moment().year()

        view
    ]
]
